import React, { useState, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';
import { Spinner } from 'react-bootstrap';

const Dominance = () => {
    const [tickerData, setTickerData] = useState([]);
    const [currentTime, setCurrentTime] = useState('');

    // 1초마다 현재 시간을 갱신합니다.
    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            setCurrentTime(`${year}년 ${month}월 ${day}일 ${hours}:${minutes}:${seconds}`);
        };

        updateTime(); // 컴포넌트 마운트 시 즉시 시간 설정
        const interval = setInterval(updateTime, 1000); // 1초마다 갱신

        return () => clearInterval(interval); // 컴포넌트 언마운트 시 인터벌 해제
    }, []);

    // 10초마다 티커 정보를 갱신합니다.
    useEffect(() => {
        const fetchTicker = async () => {
            try {
                const response = await fetch('https://api.upbit.com/v1/ticker/all?quote_currencies=KRW');
                const data = await response.json();
                setTickerData(data);
            } catch (error) {
                console.error('Error fetching ticker data:', error);
            }
        };

        fetchTicker();
        const interval = setInterval(fetchTicker, 10000);
        return () => clearInterval(interval);
    }, []);

    // ECharts 옵션을 생성합니다.
    const getChartOption = () => {
        const totalTradeVolume = tickerData.reduce((sum, coin) => sum + coin.acc_trade_price_24h, 0);

        const transformedData = tickerData.map(coin => {
            const dominance = ((coin.acc_trade_price_24h / totalTradeVolume) * 100).toFixed(2);
            const changeRate = (coin.signed_change_rate * 100).toFixed(2);
            const marketName = coin.market.split('-')[1];

            let color = '#808080'; // 회색 (변화 없음)
            if (coin.signed_change_rate > 0) {
                color = '#2ecc71'; // 녹색 (상승)
            } else if (coin.signed_change_rate < 0) {
                color = '#e74c3c'; // 빨간색 (하락)
            }
            
            return {
                name: marketName,
                value: coin.acc_trade_price_24h,
                dominance: dominance,
                trade_price: coin.trade_price,
                change_rate: changeRate,
                itemStyle: {
                    color: color,
                    borderWidth: 2,
                    borderColor: '#fff'
                }
            };
        });

        return {
            tooltip: {
                formatter: (info) => {
                    const { name, trade_price, change_rate, dominance } = info.data;
                    return `
                        <strong>${name}</strong><br/>
                        현재가: ${trade_price} KRW<br/>
                        변동률: ${change_rate}%<br/>
                        도미넌스: ${dominance}% (24h 거래대금 기준)
                    `;
                }
            },
            series: [{
                type: 'treemap',
                width: '100%',
                height: '100%',
                roam: false,
                data: transformedData,
                label: {
                    formatter: (params) => {
                        const { name, trade_price, change_rate, dominance } = params.data;
                        return `{name|${name}}\n{price|${trade_price.toLocaleString()}} KRW\n{change|${change_rate}%}\n{dominance|Domi: ${dominance}%}`;
                    },
                    rich: {
                        name: { fontSize: 16, fontWeight: 'bold' },
                        price: { fontSize: 14, color: '#333' },
                        change: { fontSize: 14, color: '#333' },
                        dominance: { fontSize: 12, color: '#666' }
                    }
                },
                leafDepth: 1,
            }]
        };
    };

  return (
    <div className="crypto-card-container py-4" style={{ maxWidth: 1100 }}>
      <div className="crypto-card">
        {/* 헤더 */}
        <div className="d-flex align-items-center gap-3 border-bottom pb-3 mb-4 flex-wrap">
          <span style={{ width: 12, height: 12, borderRadius: '50%', background: '#10b981', boxShadow: '0 0 12px rgba(16, 185, 129, 0.6)' }} />
          <h4 className="fw-bold m-0" style={{ letterSpacing: '-0.02em' }}>
            업비트 24h 거래대금 도미넌스 히트맵
          </h4>
          <span className="text-secondary ms-auto small font-monospace">
            🕒 조회 시간: {currentTime}
          </span>
        </div>

        <p className="text-muted small mb-3">
          💡 각 블록의 크기는 최근 24시간 동안의 누적 거래대금 규모를 나타냅니다. 
          초록색은 전일 대비 상승, 빨간색은 하락, 회색은 보합 상태를 의미합니다.
        </p>

        <div style={{ width: '100%', height: '700px', background: '#f8fafc', borderRadius: '12px', padding: '16px', border: '1px solid #edf2f7' }}>
          {tickerData.length > 0 ? (
            <ReactECharts
              option={getChartOption()}
              style={{ height: '100%' }}
            />
          ) : (
            <div className="text-center p-5">
              <Spinner animation="border" variant="success" />
              <div className="text-muted mt-2 small">거래소 실시간 정보 수신 중...</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { Dominance };